import { Meta } from 'src/components/Meta';
import { Stack } from 'src/components/Stack';
import { useSession } from 'src/contexts/SessionContext';

import PosPreview from './PosPreview';
import { PosPreviewConfigProvider } from './PosPreviewConfigContext';
import PosPreviewSideMenu from './PosPreviewSideMenu';
import PosPreviewTopBar from './PosPreviewTopBar';

export default function PosLayout() {
  const { session } = useSession();

  return (
    <>
      <Meta title="Point of Sale Preview" brand={session?.brand} />
      <Stack>
        <PosPreviewConfigProvider>
          <PosPreviewTopBar />
          <Stack direction="row">
            <PosPreviewSideMenu />
            <PosPreview />
          </Stack>
        </PosPreviewConfigProvider>
      </Stack>
    </>
  );
}
